const MONTHS_RU = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']
const MONTHS_FULL_RU = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']

export function formatNumber(n) {
  if (n === null || n === undefined) return '—'
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`
  return n.toLocaleString('ru-RU')
}

/** Full number with spaces as thousands separator — no abbreviation. */
export function formatFull(n) {
  if (n === null || n === undefined) return '—'
  return n.toLocaleString('ru-RU')
}

export function formatDate(dateStr) {
  if (!dateStr) return '—'
  const d = new Date(dateStr)
  const day = d.getDate()
  const month = MONTHS_RU[d.getMonth()]
  const year = d.getFullYear()
  const thisYear = new Date().getFullYear()
  return year === thisYear ? `${day} ${month}` : `${day} ${month} ${year}`
}

export function formatMonth(year, month) {
  return `${MONTHS_FULL_RU[month - 1]} ${year}`
}

export function erClass(er) {
  if (er === null || er === undefined) return ''
  if (er >= 6) return 'er-high'
  if (er >= 4) return 'er-mid'
  return 'er-low'
}
